import { EducatorInterface } from "../../interfaces/EducatorInterface";

export const getEducatorOptions = (
    educators?: EducatorInterface[],
): { value: string; label: string }[] => {
    if (!educators) {
        return [];
    }

    return (
        educators.map((educator: EducatorInterface) => ({
            label: educator.name,
            value: educator.id.toString(),
        })) || []
    );
};
